/* SCENE-MEMORY-01 (2026-10-07): the darkest-memory book in Zhaunil's library, in the Data Hub.
   Pages readers leave in the library's book (src/scene-pages/pages/library/memories.js) wait here. Keep puts a page in
   the book for every reader, Set aside takes it out (with a reason only the hub sees, if Jan wants one), and Put back
   returns a set-aside page to Waiting. Nothing is ever deleted. It calls the two hub doors of
   sql/SCENE-MEMORY-01-DARKEST-BOOK.sql with the hub's access word, like every panel. The list is drawn once: the hub's
   two-minute refresh only updates the counts, so a review in progress keeps its place (the refresh button, a view
   button or the pager draw it again). Before that SQL runs the doors answer 404 and the panel says so. */
(function(){
 'use strict';
 window.ffBookDataHub=function(ctx){
  const {el,n,chip,esc,rpc,key}=ctx,stat=typeof ctx.stat==='function'?ctx.stat:function(){};
  const CLS={barbarian:'Barbarian',bard:'Bard',cleric:'Cleric',druid:'Druid',fighter:'Fighter',monk:'Monk',paladin:'Paladin',ranger:'Ranger',rogue:'Rogue',sorcerer:'Sorcerer',warlock:'Warlock',wizard:'Wizard',artificer:'Artificer',bloodhunter:'Blood Hunter',other:'Adventurer'};
  const KIND={loss:'A loss',mistake:'A mistake',promise:'A broken promise',betrayal:'A betrayal',fear:'A fear',rival:'A rival'};
  const FLAG={'real-life':'Real life?','self-harm':'Self-harm words','swearing':'Swearing','check-word':'A word to check'};
  const REASONS=['It names a real person or place','It is not a memory','Too rough for the book','Copied from somewhere'];
  const EMPTY={waiting:'Nothing is waiting. New pages show here first.',kept:'No page is in the book yet. Keep one from Waiting.',aside:'Nothing is set aside.'};
  const PAGE=30;
  let view='waiting',offset=0,loaded=false,seq=0,rows=[],more=false,total=0;
  const date=v=>{const d=new Date(v);return Number.isNaN(d.getTime())?'':d.toLocaleDateString(undefined,{month:'short',day:'numeric'});};
  function counts(c,open){
   c=c||{};total=c[view]||0;
   el('book-chips').innerHTML=[['Waiting for you',c.waiting],['In the book',c.kept],['Set aside',c.aside]].map(([l,v])=>chip(l,n(v||0))).join('');
   el('book-closed').hidden=open!==false;
   stat('book',{waiting:c.waiting||0,kept:c.kept||0,aside:c.aside||0,open:open!==false});
  }
  function card(r){
   const acts=view==='waiting'?'<button type="button" class="fh-rbtn approve" data-act="keep">Keep</button><button type="button" class="fh-rbtn reject" data-act="why">Set aside</button>'
    :view==='kept'?'<button type="button" class="fh-rbtn reject" data-act="why">Set aside</button>'
    :'<button type="button" class="fh-rbtn ghost" data-act="restore">Put back</button><button type="button" class="fh-rbtn approve" data-act="keep">Keep</button>';
   return '<article class="fh-bk-card" data-id="'+esc(r.id)+'"><div class="fh-bk-head"><b class="fh-bk-name">'+esc(r.name)+'</b><span class="fh-bk-meta">'+esc(CLS[r.cls]||r.cls)+' · '+esc(KIND[r.kind]||r.kind)+' · '+esc(date(r.created_at))+'</span>'
    +(r.page?'<span class="fh-bk-no">Page '+esc(r.page)+'</span>':'')+'</div>'
    +((r.flags||[]).length?'<p class="fh-bk-flags">'+r.flags.map(f=>'<span class="fh-bk-flag">'+esc(FLAG[f]||f)+'</span>').join('')+'</p>':'')
    +'<p class="fh-bk-body">'+esc(r.body)+'</p>'
    +(view==='aside'?'<p class="fh-bk-why">'+(r.reason?'Set aside: '+esc(r.reason):'Set aside with no reason.')+'</p>':'')
    +'<div class="fh-bk-acts">'+acts+'<span class="fh-bk-said" role="status"></span></div>'
    +'<div class="fh-bk-reasons" hidden><p>Why set it aside? Only you see this.</p>'+REASONS.map((t,i)=>'<button type="button" class="fh-rbtn ghost" data-act="aside" data-r="'+i+'">'+esc(t)+'</button>').join('')
    +'<button type="button" class="fh-rbtn ghost" data-act="aside">No reason</button><button type="button" class="fh-rbtn ghost" data-act="cancel">Cancel</button></div></article>';
  }
  function paint(){
   el('book-list').innerHTML=rows.length?rows.map(card).join(''):'<div class="fh-empty">'+EMPTY[view]+'</div>';
   el('book-pager').hidden=!(offset||more);
   el('book-page').textContent=rows.length?(offset+1)+' to '+(offset+rows.length)+' of '+n(total):'';
   el('book-prev').disabled=offset===0;el('book-next').disabled=!more;
  }
  async function list(k){
   k=k||key();if(!k)return;
   const request=++seq;el('book-report').setAttribute('aria-busy','true');
   try{
    const d=await rpc('datahub_memories_queue',{p_key:k,p_view:view,p_offset:offset});
    if(request!==seq)return;
    if(!d||d.error){el('book-chips').innerHTML='<div class="fh-empty">'+(d&&d.error==='bad key'?'The access word was not accepted. Refresh and type it again.':'The book did not load. It tries again on the next refresh.')+'</div>';el('book-list').innerHTML='';el('book-pager').hidden=true;loaded=false;return;}
    counts(d.counts,d.open);rows=d.rows||[];more=!!d.more;paint();
   }catch(e){
    if(request!==seq)return;
    const none=e&&e.status===404;loaded=false;
    el('book-chips').innerHTML='<div class="fh-empty">'+(none?'The book is not shared yet. It appears once its database step (SCENE-MEMORY-01) has run.':'The book did not load. It tries again on the next refresh.')+'</div>';
    el('book-list').innerHTML='';el('book-pager').hidden=true;
    if(none)stat('book',{none:true,waiting:0});
   }finally{if(request===seq)el('book-report').setAttribute('aria-busy','false');}
  }
  /* the two-minute refresh: the counts only, never the list under Jan's hands */
  async function load(k){
   k=k||key();if(!k)return;
   if(!loaded){loaded=true;return list(k);}
   try{const d=await rpc('datahub_memories_queue',{p_key:k,p_view:view,p_offset:offset});if(d&&!d.error&&d.counts)counts(d.counts,d.open);}catch(_){}
  }
  async function act(c,action,reason){
   const btns=[...c.querySelectorAll('button')],said=c.querySelector('.fh-bk-said');
   btns.forEach(b=>{b.disabled=true;});
   try{
    const body={p_key:key(),p_ids:[c.dataset.id],p_action:action};if(reason)body.p_reason=reason;
    const d=await rpc('datahub_memories_review',body);
    if(!d||d.error){said.textContent=d&&d.error==='bad key'?'The access word was not accepted.':'That did not save. Try again.';btns.forEach(b=>{b.disabled=false;});return;}
    if(d.same){said.textContent='The same words are already waiting or in the book, so this page stays set aside.';btns.forEach(b=>{b.disabled=false;});return;}
    rows=rows.filter(r=>r.id!==c.dataset.id);total=Math.max(0,total-1);
    c.remove();
    if(!rows.length){if(offset){offset=Math.max(0,offset-PAGE);}list();return;}
    el('book-page').textContent=(offset+1)+' to '+(offset+rows.length)+' of '+n(total);
    try{const q=await rpc('datahub_memories_queue',{p_key:key(),p_view:view,p_offset:offset});if(q&&!q.error&&q.counts)counts(q.counts,q.open);}catch(_){}
   }catch(_){said.textContent='That did not save. Try again.';btns.forEach(b=>{b.disabled=false;});}
  }
  el('book-list').addEventListener('click',e=>{
   const b=e.target.closest('button[data-act]'),c=b&&b.closest('.fh-bk-card');if(!c||b.disabled)return;
   const a=b.dataset.act,box=c.querySelector('.fh-bk-reasons'),acts=c.querySelector('.fh-bk-acts');
   if(a==='why'){box.hidden=false;acts.hidden=true;return;}
   if(a==='cancel'){box.hidden=true;acts.hidden=false;return;}
   if(a==='aside'){box.hidden=true;acts.hidden=false;act(c,'aside',b.dataset.r!=null?REASONS[+b.dataset.r]:null);return;}
   act(c,a);
  });
  el('book-views').addEventListener('click',e=>{
   const b=e.target.closest('button[data-bv]');if(!b)return;
   view=b.dataset.bv;offset=0;
   [...el('book-views').querySelectorAll('button')].forEach(x=>x.classList.toggle('on',x===b));
   list();
  });
  el('book-prev').addEventListener('click',()=>{offset=Math.max(0,offset-PAGE);list();});
  el('book-next').addEventListener('click',()=>{offset+=PAGE;list();});
  const again=document.getElementById('fh-refresh');if(again)again.addEventListener('click',()=>{loaded=true;list();});
  return {load};
 };
 window.dispatchEvent(new Event('ff-book-report-ready'));
})();
